import React, { useEffect } from "react";
import MainNavigator from "./routes/navigation";
import { IKContext } from "imagekitio-react";
import { useSelector } from "react-redux";
import { FcCancel } from "react-icons/fc";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import 'pure-react-carousel/dist/react-carousel.es.css';
import AOS from "aos";
import "aos/dist/aos.css";

const App = () => {
  

  const isLoading = useSelector((state) => state.loading.isLoading);
 
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true 
    });
  }, []);

  

  return (
    <IKContext
      publicKey="public_SWufzC3NBuBYZKszPsXhFdh1XDo="
      urlEndpoint="https://ik.imagekit.io/saufrbirqu"
    >
      {isLoading ? (
        <div>
          <button  className="bg-indigo-500 ..." disabled>
            <svg className="animate-spin h-5 w-5 mr-3 ..." viewBox="0 0 24 24">
              <FcCancel />
            </svg>
            Processing...
          </button>
        </div>
      ) : (
        <MainNavigator />
      )}

      <ToastContainer autoClose={3000}/>
     
    </IKContext>
  );
};

export default App;
